import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkflowNodeConfigBase } from './node-config-base';

/** ANNOTATION / TEXT_NOTE — nota visual sin efecto en la ejecución. */
@Component({
  selector: 'app-wf-annotation-config',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="space-y-2">
      <label [class]="labelClass">Texto de la nota</label>
      <textarea
        rows="5"
        [class]="fieldClass"
        [value]="str('text')"
        [disabled]="readOnly()"
        placeholder="Escribe una anotación para documentar el flujo…"
        (input)="patchConfig({ text: inputValue($event) })"></textarea>
      <p [class]="hintClass">Solo es visible en el lienzo; no ejecuta ninguna acción.</p>
    </div>
  `
})
export class WorkflowAnnotationConfigComponent extends WorkflowNodeConfigBase {}
